export interface BulkTaskStatus {
  taskId: string;
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  progress: {totalRecords: number; numberProcessed: number};
  result: {successCount: number; errorCount: number};
}

const INITIAL_POLL_INTERVAL_MS = 1000;
const POLL_INTERVAL_INCREMENT_MS = 1000;
const MAX_POLL_INTERVAL_MS = 5000;
const MAX_POLL_DURATION_MS = 10 * 60 * 1000;

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

const MAX_ITERATIONS = Math.ceil(MAX_POLL_DURATION_MS / INITIAL_POLL_INTERVAL_MS);

export async function pollBulkTaskUntilDone(
  pollingUri: string,
  onProgress?: (status: BulkTaskStatus) => void
): Promise<BulkTaskStatus> {
  let interval = INITIAL_POLL_INTERVAL_MS;
  const startTime = Date.now();

  for (let i = 0; i < MAX_ITERATIONS; i++) {
    await sleep(interval);
    if (Date.now() - startTime > MAX_POLL_DURATION_MS) {
      break;
    }
    const response = await fetch(pollingUri, {credentials: 'same-origin'});
    if (!response.ok) {
      throw new Error(`Bulk task polling failed: ${response.status}`);
    }
    const status: BulkTaskStatus = await response.json();
    onProgress?.(status);
    if (status.status === 'COMPLETED' || status.status === 'FAILED') {
      return status;
    }
    interval = Math.min(interval + POLL_INTERVAL_INCREMENT_MS, MAX_POLL_INTERVAL_MS);
  }
  throw new Error('Bulk task polling timed out.');
}

export async function downloadErrorsAsCsv(taskId: string): Promise<void> {
  const response = await fetch(`/1/api/molecules:bulk-import-errors-csv/${taskId}`, {
    credentials: 'same-origin',
  });
  if (!response.ok) {
    return;
  }
  const data = (await response.json()) as {csvUrl: string};
  const a = document.createElement('a');
  a.href = data.csvUrl;
  a.download = 'import-errors.csv';
  a.click();
}
